<template>
  <div class="docView">
    <div class="docHtml"
         ref="docHtml"
         v-html="html"
         @click="selectDiv"
    >
    </div>
  </div>
</template>

<script>
import { requestUrl } from "@/http/requestUrl";
export default {
  name: "docView",
  data(){
    return{
      colors: ['#E3EBFF', '#FFF5DC', '#FFE8D8','#D6F3EA','#FFF1C3'],
      html:""
    }
  },
  props:{
    html_result:{
      type:String,
      default:""
    },
    split_paragraphs:{
      type:Array,
      default(){
        return []
      }
    },
    fileSuffix:{
      type:String,
      default:""
    }
  },
  methods:{
    selectDiv(e){
      this.$emit('selectDiv',e)
    },
    getHtml(){
      console.log("开始解析 html_result:", this.html_result);
      console.log("文件后缀:", this.fileSuffix);

      // 直接获取 HTML 内容（html_result 已经是带签名的）
      this.$http.get(this.html_result).then(res => {
        let htmlContent = res.data;
        console.log("原始 HTML 内容长度:", htmlContent.length);
        
        // 针对Markdown文件的特殊处理
        if (this.fileSuffix === 'md' || this.fileSuffix === 'markdown') {
          console.log("检测到Markdown文件，进行特殊处理");
          // 确保Markdown的HTML内容有正确的样式
          if (!htmlContent.includes('<style>')) {
            htmlContent = `
              <style>
                body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; line-height: 1.6; }
                h1, h2, h3, h4, h5, h6 { margin-top: 24px; margin-bottom: 16px; font-weight: 600; line-height: 1.25; }
                h1 { font-size: 2em; border-bottom: 1px solid #eaecef; padding-bottom: 0.3em; }
                h2 { font-size: 1.5em; border-bottom: 1px solid #eaecef; padding-bottom: 0.3em; }
                h3 { font-size: 1.25em; }
                p { margin-bottom: 16px; }
                code { background-color: rgba(27,31,35,0.05); border-radius: 3px; font-size: 85%; margin: 0; padding: 0.2em 0.4em; }
                pre { background-color: #f6f8fa; border-radius: 6px; font-size: 85%; line-height: 1.45; overflow: auto; padding: 16px; }
                pre code { background-color: transparent; margin: 0; padding: 0; }
                blockquote { border-left: 4px solid #dfe2e5; color: #6a737d; margin: 0; padding: 0 16px; }
                table { border-collapse: collapse; border-spacing: 0; width: 100%; }
                table th, table td { border: 1px solid #dfe2e5; padding: 6px 13px; }
                table th { background-color: #f6f8fa; font-weight: 600; }
                img { max-width: 100%; height: auto; }
              </style>
              ${htmlContent}
            `;
          }
        }
        // 处理 HTML 中的图片链接，为私有 OSS 图片添加签名
        this.processImagesInHtml(htmlContent).then(processedHtml => {
          this.html = processedHtml;
          this.$nextTick(() => {
            this.setColor();
          });
        }).catch(err => {
          console.error("图片处理失败，使用原始HTML:", err);
          this.html = htmlContent;
          this.$nextTick(() => {
            this.setColor();
          });
        });
      }).catch(err => {
        console.error("获取 HTML 内容失败:", err);
      });
    },
    
    // 处理 HTML 中的图片链接，为私有 OSS 图片添加签名
    async processImagesInHtml(htmlContent) {
  // Match img tags with both single and double quotes for src attribute
  const imgRegex = /<img[^>]*src\s*=\s*["']([^"']+)["'][^>]*>/gi;
  let match;
  const imageUrls = [];

  // Collect all image URLs
  while ((match = imgRegex.exec(htmlContent)) !== null) {
    const imgUrl = match[1];
    if (imgUrl && imgUrl.includes('oss-cn-zhangjiakou.aliyuncs.com') && !imgUrl.includes('Expires=')) {
      imageUrls.push(imgUrl);
    } else {
      console.log("跳过图片 URL:", imgUrl, "原因:", !imgUrl ? "空URL" : !imgUrl.includes('oss-cn-zhangjiakou.aliyuncs.com') ? "非OSS" : "已有签名");
    }
  }

  // Get signed URLs for each image
  const signedUrls = {};
  for (const imgUrl of imageUrls) {
    try {
      const previewApi = requestUrl.preview.previewUrl + '?isVersionManage=1&needEncrypt=false';
      const resp = await this.$http.post(previewApi, { fileInOssPath: imgUrl });
      if (resp.data && resp.data.code === "0") {
        signedUrls[imgUrl] = resp.data.data;  // Use only the signed URL
      } else {
        console.error("签名接口返回错误:", resp.data);
      }
    } catch (err) {
      console.error("图片签名失败:", imgUrl, err);
      console.error("错误详情:", err.response ? err.response.data : err.message);
    }
  }

  // Replace image URLs in the HTML
  let processedHtml = htmlContent;
  Object.keys(signedUrls).forEach(originalUrl => {
    const signedUrl = signedUrls[originalUrl];
    // Use more secure replacement logic
    const escapedUrl = originalUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    processedHtml = processedHtml.replace(new RegExp(escapedUrl, 'g'), signedUrl);
    // console.log("替换图片链接:", originalUrl, "->", signedUrl);
  });

  console.log("处理完成，替换了", Object.keys(signedUrls).length, "个图片链接");
  return processedHtml;
},
    setColor(){
      this.split_paragraphs.forEach((item,index) => {
        const colorIndex = index % this.colors.length;
        if (item.original_paragraph){
          item.original_paragraph.forEach(items => {
            const dom =
              document.getElementById(items.paragraph_id) ||
              this.$el.querySelector(`[data-paragraph-id="${items.paragraph_id}"]`) ||
              this.$el.querySelector(`[paragraph-id="${items.paragraph_id}"]`);
            if (this.$route.query.fileSuffix === 'txt'){
              const paragraphs = this.$el.querySelectorAll(`[paragraph-id="${items.paragraph_id}"]`);
              paragraphs.forEach(paragraph => {
                paragraph.style.background = this.colors[colorIndex]
              })
            } else if (dom){
              dom.style.background = this.colors[colorIndex];
            }
          })
          let newOriginal = item.original_paragraph.filter(items => !items.type)
          if (newOriginal.length > 0){
            const lastId = newOriginal[newOriginal.length - 1].paragraph_id;
            const dom =
              document.getElementById(lastId) ||
              this.$el.querySelector(`[data-paragraph-id="${lastId}"]`) ||
              this.$el.querySelector(`[paragraph-id="${lastId}"]`);
            if (dom){
              dom.style.marginBottom = '8px';
            }
          }
        }
      })
    },
  },
  watch:{
    html_result:{
      handler(){
        if (this.html_result){
          this.getHtml();
        }
      },
      immediate:true
    }
  }
};
</script>

<style scoped lang="less">
.docView{
  width: 100%;
  flex: none;
  box-sizing: border-box;
  div{
    position: relative;
  }
  /deep/img{
    max-width: 100%;
  }
}
</style>
